// extracted by mini-css-extract-plugin
export default {"formBtn":"styles_formBtn__ZteiE","selectedFile":"styles_selectedFile__1tube","selectedFileName":"styles_selectedFileName__z9smE","confirmMessage":"styles_confirmMessage__te1du"};